import { useEffect, useRef } from "react";
import { Dropdown } from "../dropdown/Dropdown";
import "./Navigation.css";
import { Link, useLocation } from "wouter";

export function Navigation({ login, userName }) {

    const nav = useRef(null);
    const [location, setLocation] = useLocation();

    useEffect(() => {
        console.log("Navigation");

        const handleScroll = () => {
            console.log('Se ha hecho scroll en la página', window.scrollY);

            if (nav.current) {
                if (window.scrollY > 124) {
                    nav.current.classList.add('sticky');
                } else {
                    nav.current.classList.remove('sticky');
                }
            }
        };

        window.addEventListener('scroll', handleScroll);

        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [])

    const closeSession = () => {
        localStorage.removeItem("vitaly_userid");
        //localStorage.removeItem("vitaly_token");
        window.location.href = "/"
    };
    return (
        <div>

            <div className="info-header">
                <div>
                    <a href="">Politicas de privacidad</a>
                    <a href="">Terminos y condiciones</a>
                </div>

                <div>
                    <a href="">Registrarme</a>
                    |
                    <a href="">Ayuda</a>
                </div>
            </div>

            <div className="navigation" ref={nav}>

                <div className="navigation-info">
                    <Link to="/">
                        <div className="logo">
                            <img width={"100%"} src="/assets/vitaly.webp" alt="Logo vitaly" />
                        </div>
                    </Link>

                    <div className="links">
                        <div>|</div>
                        <Dropdown title="Lecheria" />
                        <Dropdown title="Explora" />
                        <Dropdown title="Categorias" />
                        <Dropdown title="Mas" />
                    </div>
                </div>

                <div className="buttons">
                    {
                        login == false &&
                        <>
                            <Link to="/login" style={{ marginRight: "10px" }}>
                                <button className="btn btn-primary">
                                    Iniciar sesion
                                </button>

                            </Link>

                            <Link to="/register">
                                <button className="btn btn-primary">
                                    Registrate
                                </button>
                            </Link>
                        </>
                    }

                    {
                        login && userName &&
                        <div class="dropdown">
                            <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenu2" data-bs-toggle="dropdown" aria-expanded="false">
                                Bienvenido, {userName}
                            </button>
                            <ul class="dropdown-menu" aria-labelledby="dropdownMenu2">
                                <li>
                                    <Link to="/panel">
                                        <button class="dropdown-item" type="button">
                                            Ir al Panel
                                        </button>
                                    </Link>
                                </li>
                                <li>
                                    <button class="dropdown-item" type="button" onClick={closeSession}>
                                        Cerrar sesión
                                    </button>
                                </li>
                            </ul>
                        </div>

                    }
                </div>

            </div>

            {/* <Link to="/">Home</Link>
            <Link to="/search">Search</Link>
            <Link to="/provider-profile">Provider Profile</Link> */}
        </div>
    );
}